// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"eb228318","977":"b7824186"}[chunkId] + ".chunk.js";
};